import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

export const useStateStore = defineStore('StateStore', {
    state: () => {
        return {
            states: null,
            route: useRoute(),
            router: useRouter(),
        }
    },
    persist: {
        paths: ['states'],
        debug: false
    },
    actions: {
        async fetchState() {
            const route = this.router.resolve(
                {
                    name: 'states'
                }
            );
            try {
                this.states = await axios.get(route.href)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {
        select2State: (state) => {
            return () => {
                if (state.states && state.states.length > 0) {
                    return state.states.map(({ label }) => (label));
                }
                return null;
            }
        },
    },
})